import { platformToCategoryMap } from '../static-data/configDropdownOptions';

export const checkRequiredFieldsInCycle = (formData) => {
    if (!formData?.platforms?.length) {
      return 'Please select at least one platform.';
    }
    const needsSubPlatforms = formData?.platforms?.some(
      platform => platformToCategoryMap[platform]
    );
    if (needsSubPlatforms && (!formData?.subPlatforms || !formData?.subPlatforms.length)) {
      return 'Please select supported options for selected platforms.';
    }
  
    return '';
  };
  

  export const generateEntityUrl = (entityType, params) => {
    const { projectId, entityKey } = params;
  
    switch (entityType) {
      case 'TestCase':
        return `/project/${projectId}/testcases/${entityKey}`;
      case 'TestCycle':
        return `/project/${projectId}/testcycles/${entityKey}`;
      case 'Execution':
        return `/project/${projectId}/testexecution/${entityKey}`;
      default:
        return '/';
    }
  };
  
export const getTestCycleKeyFromLocation = (location) => {
  const queryParams = new URLSearchParams(location.search);
  const queryTestCycleKey = queryParams.get('testcycle');

  const pathMatch = location.pathname.match(/\/testcycles\/([^/]+)/);
  const pathTestCycleKey = pathMatch?.[1];

  return queryTestCycleKey || pathTestCycleKey || null;
};
